import gql from 'graphql-tag';

export const SearchDispatchIssueDocument = gql`
  query SearchDispatchIssueDocument($input: DispatchIssueDocumentConnectionInput) {
    searchDispatchIssueDocument {
      dispatchIssueDocumentConnection(input: $input) {
        totalCount
        edges {
          node {
            id
            createdAt
            createdBy
            updatedAt
            updatedBy
            issueId
            filename
            fileLocation
            contentType
            fileSize
            md5
          }
          cursor
        }
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
      }
    }
  }
`;
